import { useMemo } from 'react'
import { getStoredProfileId } from './authTokens'

/**
 * Свой profile id — по нему сообщение в ленте уходит вправо.
 *
 * Читается синхронно из localStorage, а не кладётся в ref из эффекта: ref в
 * первом рендере ещё пуст, и все свои сообщения успевают отрисоваться чужими.
 */
export function useMyProfileId(): number | null {
  return useMemo(() => getStoredProfileId(), [])
}
